<div class="formly-field-wrap">
  @if(!options.formState.disabled && !field.props['disabled'] && !field.props['readonly']) {
    <div [class]="'content-editor ' + (field.props['disabled'] ? ' disabled ' : 'enabled')">
      <quill-editor 
        [formControl]="$any(formControl)" 
        [modules]="{ toolbar: getQuillConfig().toolbar }"
        [theme]="getQuillConfig().theme"
        (onEditorCreated)="onEditorCreated($event)"
        (onContentChanged)="onContentChanged($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        placeholder="{{field.props.placeholder || field.props.label || '' | translate}}"
        [style]="{ height: '200px', width: '100%' }">
      </quill-editor>
      <div class="char-counter">
        <span class="char-count">
          {{ getCharacterCount() }}/{{ getMaxContentLength() }}
        </span>
      </div>
    </div>
  } @else {
    <div [class]="(options.formState.showCompactViewWhenDisabled ? 'compact-' : '') + 'disabled-text'">
      <span [innerHTML]="domSanitizer.bypassSecurityTrustHtml(formControl.value)"></span>
    </div>
  }
  <ng-template #fieldComponent></ng-template>
</div>